export const options = {
    sectionClassName: 'section',
    anchors: ['MAIN', 'COREDOT', 'MISSIONS1', 'MISSIONS2', 'MISSIONS3', 'COMMUNITY', 'CONTACT'],
    scrollBar: false,
    navigation: false,
    verticalAlign: false,
    arrowNavigation: false,
    delay: 1000,
};
